module.exports = __webpack_public_path__ + "gallery-v2.img.instagram-anonymous.e85f09917b64c1249b46a19cadc57744.png";